import request from '@/utils/changanRequest'
export function addEmployment(data) {
  return request({
    url: '/system/employment',
    method: 'post',
    data: data
  })
}

// 查询招聘求职详细
export function getEmployment(id) {
  return request({
    url: '/system/employment/' + id,
    method: 'get'
  })
}